export const PLAYGROUP_MASKED_STATUS = {
	'in use': 'Activated',
	overflow: 'Deactivated'
}
export const PLAY_STYLES = {
	low: 'Low Contact',
	hight: 'High Contact',
	fast: 'Fast',
	puppy: 'Puppy Play',
	other: 'Other'
}
export const STATUS_ID = {
	Pending: 1,
	Approved: 2,
	ChangeRequested: 3,
	InProgress: 4,
	Completed: 5,
	Cancelled: 7,
	'No Show': 8
}

export const MARKET_LAUNCH_STATES = {
	inactive: 'State 0 - Inactive',
	pre_launch_no_memberships: 'State 1 - Active No Sales',
	pre_launch_with_memberships: 'State 2 - Active Presale',
	post_launch_limited_services: 'State 3 - Active Partially Open',
	fully_open: 'State 4 - Active Fully Open'
}

export const MEM_TYPE_STATUSES = {
	inactive: 'Inactive',
	secret: 'Secret',
	waitlist: 'Waitlist',
	sold_out: 'Sold Out',
	active: 'Active'
}

export const ACTIVE_INACTIVE_VALUES = {
	inactive: 'Inactive',
	active: 'Active'
}

export const ENABLED_DISABLED_VALUES = {
	enabled: 'Enabled',
	disabled: 'Disabled'
}

export const TRIAL_MEM_PROMO_TYPES = {
	free_months: 'Free Month(s)',
	discount: 'Discount',
	other: 'Other'
}

export const BILLING_TYPE = {
	annual: 'Annual',
	monthly: 'Monthly'
}

export const BUCKET_TYPE = {
	pet_care: 'Pet Care',
	bar: 'Bar',
	vip: 'VIP'
}

export const TIME_ZONE_ABBREVIATIONS = {
	'America/Los_Angeles': 'PST',
	'America/Denver': 'MST',
	'America/Chicago': 'CST',
	'America/New_York': 'EST'
}

export const PLAYGROUP_STATUSES = {
	'in use': 'Active',
	overflow: 'Overflow',
	disabled: 'Disabled'
}

export const KENNEL_STATUSES = {
	yes: 'Active',
	disabled: 'Disabled'
}

export const MEMBERSHIP_TYPES_ENUM = {
	bar_annual: 'bar_annual',
	bar_monthly: 'bar_monthly',
	vip_annual: 'vip_annual',
	vip_monthly: 'vip_monthly',
	vip_trial: 'vip_trial',
	pet_care_annual: 'pet_care_annual',
	pet_care_monthly: 'pet_care_monthly',
	founding: 'founding',
	grooming_annual: 'grooming_annual',
	grooming_monthly: 'grooming_monthly'
}

export const FONT_WEIGHTS = {
	Thin: 100,
	ExtraLight: 200,
	Light: 300,
	Normal: 400,
	Medium: 500,
	SemiBold: 600,
	Bold: 700,
	ExtraBold: 800,
	Black: 900
}

export const TIME_BLOCKS = {
	Morning: 'morning',
	Midday: 'midday',
	Evening: 'evening'
}
export const USER_ROLES = {
	BackOfficeUser: 'Back Office User',
	PcaSupervisorUser: 'PCA Supervisor User',
	SupportUser: 'Support User',
	Groomer: 'Groomer',
	SuperUser: 'Super User'
}

export const LINE_ITEM_TYPES = {
	Boarding: 'boarding',
	Daycare: 'daycare',
	Deposit: 'deposit',
	SignaturePlay: 'signature_play',
	Petcare: 'petcare',
	Addon: 'addon',
	Grooming: 'grooming',
	GroomingAddon: 'grooming_addon',
	PetcareCancellation: 'petcare_cancellation',
	PetcareNoShow: 'petcare_noshow',
	CreditsUsed: 'credits_used',
	Credit: 'credit',
	VisitPromo: 'visit_promo',
	ManualDiscount: 'manual_discount',
	AppliedPromoCode: 'applied_promo_code',
	PreLineItemAppliedPromo: 'pre_line_item_applied_promo', // A pretend line item for visits that have not been completed.
	Training: 'training',
	ExtendedPickup: 'extended_pickup',
	EarlyDropoff: 'early_dropoff',
	HouseholdCredit: 'household_credit',
	AddonBank: 'addon_bank'
}

export const VACCINES = {
	1: 'Rabies',
	2: 'Bordetella',
	3: 'Distemper & Parvovirus'
}

export const VACCINE_LABELS = [
	{ name: VACCINES[1], id: 1 },
	{ name: VACCINES[2], id: 2 },
	{ name: VACCINES[3], id: 3 }
]

export const ADMIN_ONLY = 'Admin Only'
export const GLOBAL_ACCESS = 'Global Access'

export const ACCESS_TYPES = {
	AdminOnly: ADMIN_ONLY,
	GlobalAccess: GLOBAL_ACCESS
}
